import { lazy } from 'react';

export const LazyPreload = lazy(
	() =>
		import(/* webpackChunkName: "prefetch-search-page-results" */ './prefetch-search-page-results'),
);
